import { useBaseDados } from "./use-base-dados";
import { BaseDadosView } from "./view-base-dados";

export function BaseDadosScreen() {
  const vm = useBaseDados();

  return <BaseDadosView {...vm} />;
}

export type * from "./types-base-dados";
